import React from 'react';

export const Entry = () => {
    return (
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="48" cy="48" r="48" fill="#F6F8FA" />
            <circle cx="47.2607" cy="47.2607" r="25.2607" fill="white" />
            <g filter="url(#filter0_d)">
                <path
                    d="M73.9994 48.0003C73.9994 62.3579 62.3573 74 47.9997 74C33.6421 74 22 62.3579 22 48.0003C22 33.6427 33.6421 22.0006 47.9997 22.0006C62.3573 22.0006 73.9994 33.6427 73.9994 48.0003Z"
                    stroke="#0075DB"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <g filter="url(#filter1_d)">
                <path
                    d="M57.8334 46.4216C57.8334 53.0089 54.563 58.3516 48.1403 58.3516C41.7177 58.3516 38.4473 53.0089 38.4473 46.4216C38.4473 39.8343 41.7177 34.4917 48.1403 34.4917C54.563 34.4917 57.8334 39.8343 57.8334 46.4216Z"
                    fill="#EBF6FF"
                    stroke="#0075DB"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.2927 67.5324C34.058 64.2012 38.2542 62.0762 42.9523 62.0762H51.5684C56.6174 62.0762 61.0869 64.5306 63.8234 68.2989C59.5272 71.8573 54.0127 73.9962 47.9993 73.9962C41.5658 73.9962 35.7032 71.548 31.2927 67.5324Z"
                    fill="#EBF6FF"
                    stroke="#0075DB"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <filter id="filter0_d" x="16" y="18" width="63.9994" height="63.9994" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter
                    id="filter1_d"
                    x="25.2927"
                    y="30.4922"
                    width="44.5307"
                    height="51.504"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
